<template>
  <div class="bv-foot">
    <div class="container foot-flex">
      <div class="foot-info">
        <div class="f-logo">
          <img alt="" src="@/assets/images/listen/CSON.png"/>
        </div>
        <div class="f-email">EMAIL: admin@cspiration.com</div>
        <ul class="share-link">
          <li>
            <a href=""
            ><img alt="" src="@/assets/images/listen/zhi.png"
            /></a>
          </li>
          <li>
            <a href=""
            ><img alt="" src="@/assets/images/listen/bibi.png"
            /></a>
          </li>
          <li>
            <a href=""
            ><img alt="" src="@/assets/images/listen/ytb.png"
            /></a>
          </li>
        </ul>
      </div>
      <ul class="wx-cells">
        <li>
          <img alt="" src="@/assets/images/listen/wx1.png"/>
          <p>北美CS刷题求职群</p>
        </li>
        <li>
          <img alt="" src="@/assets/images/listen/wx2.png"/>
          <p>Cspiration官方公众号</p>
        </li>
      </ul>
      <div class="foot-lks">
        <ul class="foot-lk">
          <li><a href="">隐私政策</a></li>
          <li><a href="">CSON</a></li>
          <li><a href="">用户协议</a></li>
          <li><a href="">版权保护</a></li>
          <li><a href="">内推人计划</a></li>
        </ul>
        <div class="fh">Cspiration</div>
      </div>
    </div>
    <div class="copyright">
      浙P备105375 8Copyright8号2017cso有限公司粤CP备11053758号
    </div>
  </div>
</template>
<script>
export default {
  name: "Foot",
  data() {
    return {};
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style scoped>
.bv-foot {
  background-image: linear-gradient(to top, #282828, #696969);
}

.foot-flex {
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wx-cells li {
  display: inline-block;
  text-align: center;
  padding: 0 20px;
  color: #fff;
}

.wx-cells li img {
  border-radius: 5px;
  width: 120px;
  height: 120px;
}

.wx-cells li p {
  font-size: 12px;
  margin-top: 10px;
}

.foot-info .f-email {
  font-size: 14px;
  color: #ffffff;
  margin: 10px 0;
}

.share-link {
  display: flex;
  align-items: center;
}

.share-link li {
  margin-right: 10px;
}

.bv-foot .copyright {
  border-top: 1px solid #504f4f;
  font-size: 14px;
  color: #999999;
  padding: 15px;
  text-align: center;
  font-size: 12px;
}

.foot-lks {
  position: relative;
}

.foot-lk li a {
  color: #fff;
  font-size: 12px;
}

.foot-lk li {
  text-align: right;
  margin: 6px 0;
}

.foot-lks .fh {
  color: #1181cc;
  text-decoration: underline;
  text-transform: uppercase;
  position: absolute;
  right: -70px;
  top: 50px;
  transform: rotateZ(90deg);
  line-height: 1;
  font-size: 18px;
}
</style>
